import { IsUUID, IsNotEmpty, IsBoolean, IsString } from 'class-validator';

export class UpdateEventTypeDisabledDto {
  @IsBoolean()
  @IsNotEmpty()
  disabled: boolean;

  @IsString()
  @IsNotEmpty()
  eventTypeName: string;

  @IsUUID()
  @IsNotEmpty()
  eventTypeId: string;

  @IsUUID()
  @IsNotEmpty()
  companyId: string;
}
